import { useTranslation } from 'next-i18next';
import React, { useCallback, useMemo } from 'react';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { Typography } from 'src/ui/common/atoms/typography';
import { StyledClearBtn, StyledFilters, StyledIcon, StyledVisible, StyledWrapper } from './filter-button.styles';
import { IFilterButton } from './types';

export const FilterButton: React.VFC<IFilterButton> = ({ onClear, showClearBtn, opened, onToggle, disabled }) => {
    const { t } = useTranslation(['actions']);

    const locale = useMemo(
        () => ({
            filters: t('misc.filters', { ns: 'actions' }),
            clearAll: t('misc.clearAll', { ns: 'actions' }),
        }),
        [t]
    );

    const handleClearClick = useCallback(
        (e) => {
            e.stopPropagation();
            onClear?.();
        },
        [onClear]
    );

    return (
        <StyledVisible view={['desktop', 'laptop']}>
            <StyledWrapper alignItems="center" disabled={disabled} {...(onToggle && { onClick: onToggle })}>
                <StyledFilters visible={opened}>
                    <FlexBox alignItems="center">
                        <SvgIcon width={18} height={18} variant="regular" icon="chevronLeft" />
                        <Typography size="sm" variant="title" medium color="pink500">
                            {locale.filters}
                        </Typography>
                        {showClearBtn && (
                            <StyledClearBtn size="sm" onClick={handleClearClick}>
                                {locale.clearAll}
                            </StyledClearBtn>
                        )}
                    </FlexBox>
                </StyledFilters>
                {!opened && (
                    <StyledIcon visible>
                        <SvgIcon width={24} height={24} variant="regular" icon="filter" />
                    </StyledIcon>
                )}
            </StyledWrapper>
        </StyledVisible>
    );
};
